import * as React from "react";
const SvgFiRrSatelliteDish = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-satellite-dish_svg__a)">
      <path
        fill="#062147"
        d="M20 11a1 1 0 1 1-2 0c0-2.757-2.243-5-5-5a1 1 0 1 1 0-2c3.86 0 7 3.141 7 7m-6 0a1 1 0 1 0 2 0c0-1.654-1.347-3-3-3a1 1 0 1 0 0 2 1 1 0 0 1 1 1M13 0a1 1 0 1 0 0 2c4.962 0 9 4.037 9 9a1 1 0 1 0 2 0c0-6.065-4.936-11-11-11m3.246 18.351c.552.552.82 1.313.74 2.09a2.6 2.6 0 0 1-1.176 1.914 10.17 10.17 0 0 1-5.549 1.635A10.26 10.26 0 0 1 3 21.001C-.4 17.603-.97 12.215 1.646 8.188a2.6 2.6 0 0 1 1.913-1.174 2.56 2.56 0 0 1 2.09.739l4.592 4.591 1.052-1.052a.999.999 0 1 1 1.414 1.414l-1.053 1.052 4.592 4.591zm-1.414 1.414L4.235 9.168A.56.56 0 0 0 3.83 9a.57.57 0 0 0-.507.277c-2.104 3.239-1.645 7.574 1.09 10.309s7.07 3.193 10.308 1.091a.6.6 0 0 0 .274-.445.56.56 0 0 0-.163-.467"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-satellite-dish_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSatelliteDish;
